<template>
    <div class="mid-pane">

        <!--    Mobile left Pane-->
        <mobile-left-bar></mobile-left-bar>
        <!--    Mobile left Pane END-->

        <div class="hold">
            <!--        NavBar-->
            <div class="nav-bar">
                <p class="main">Dashboard</p>
            </div>
            <!--        card-->
            <!-- Set up your HTML -->
            <div class="accounts">
                <div class="owl-carousel owl-theme">
                    <div v-for="acct in orderedAccountList" class="item">
                        <div class="account-card alte" :class="{ 'active': currentAccountCard === acct.accountno}" @click="selectThisAccountCard(acct.accountno)">
                            <p class="account-number">
                            <span v-if="acct.account_type === 'SAVINGS'" :title="acct.account_type.toLowerCase() + ' account'">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 487.6 487.6"><path d="M451.7 178.3h-7.1c-11.8-30.3-31.6-57.8-58-80.1 -3.7-13.4-0.9-27.9 8.6-42.9 5.3-8.5 5.6-18.7 0.8-27.4 -4.8-8.6-13.8-13.9-23.5-13.9 -1.1 0-2.3 0.1-3.4 0.2 -36.5 4.5-58.7 20.8-72 36.3 -16-5-36.3-6.5-40.1-6.8 -9.4-1-19-1.6-28.5-1.6 -60.7 0-117.8 20.8-160.9 58.4 -43.6 38.1-67.6 89-67.6 143.2 0 14 1.6 28 4.9 41.7 0.1 0.3 0.1 0.6 0.2 0.8l0.1 0.5c3.4 13.8 8.5 27.3 15 40.2 10.9 23.4 23.9 43 38.5 58.1 20.2 20.8 23.7 47.2 24.2 57.8v5.2c0 0.2 0 0.5 0 0.7 0 1.1 0.1 2.1 0.3 3.1 1.9 12.4 12.6 21.9 25.4 21.9h74.5c14.2 0 25.7-11.5 25.7-25.7v-3.4c10.6 0.8 21.3 0.9 32 0.4v3c0 14.2 11.5 25.7 25.7 25.7H341c14.2 0 25.7-11.5 25.7-25.7v-18.2c0.1-4.2 1.7-24.1 20.6-41.3 0.9-0.8 1.9-1.6 2.8-2.4 0.1-0.1 0.1-0.1 0.2-0.2 0.3-0.2 0.5-0.4 0.7-0.7 24.9-22.3 43.7-49.5 54.6-79.2h5.9c19.9 0 36.1-16.2 36.1-36.1v-55.7C487.8 194.4 471.6 178.3 451.7 178.3zM372.5 40.9C372.4 40.9 372.4 40.9 372.5 40.9c-0.1-0.1-0.1-0.1-0.1-0.1s0 0 0 0.1l0 0 -1.7-13.4L372.5 40.9zM460.8 270c0 5-4.1 9.1-9.1 9.1h-15.6c-5.9 0-11.2 3.9-12.9 9.5 -8.8 28.8-26.3 55.4-50.4 76.9 -0.1 0.1-0.1 0.1-0.2 0.2l-0.1 0.1c-0.9 0.8-1.8 1.6-2.7 2.4 -0.1 0.1-0.2 0.2-0.3 0.3 -26.7 24.2-29.4 52.7-29.6 60.9 0 0.1 0 0.2 0 0.3v17.1h-72v-16.3c0-3.8-1.6-7.5-4.5-10 -2.8-2.6-6.7-3.8-10.4-3.4 -8.2 0.9-16.4 1.3-24.5 1.3 -10.5 0-21-0.7-31.3-2.1 -3.9-0.5-7.8 0.7-10.7 3.2 -2.9 2.6-4.6 6.3-4.6 10.2v17.1H110v-4.3c0-0.2 0-0.4 0-0.6 -0.6-13.5-4.9-48-31.8-75.7 -12.6-13-23.9-30.1-33.5-50.9 -0.1-0.2-0.2-0.3-0.2-0.5 -5.7-11.1-10.1-22.7-13-34.6 0-0.1-0.1-0.2-0.1-0.3 0-0.1 0-0.1 0-0.2 -2.8-11.8-4.3-23.9-4.3-35.9 0-96.3 90.4-174.6 201.5-174.6 8.6 0 17.3 0.5 25.8 1.4 0.2 0 0.4 0 0.6 0.1 11.2 0.7 32 3.6 40.3 8.1 6.1 3.3 13.7 1.4 17.6-4.3 8.7-12.9 26.1-29.2 59.5-33.3 -13.5 21.6-17.5 44-11.6 64.9 0.1 3.9 2 7.6 5 10.1 27 21.8 46.6 49.5 56.6 80 1.8 5.5 7 9.3 12.8 9.3 0.1 0 0.1 0 0.2 0h16.4c5 0 9.1 4.1 9.1 9.1v55.4H460.8z"></path></svg>
                            </span>
                                <span v-if="acct.account_type === 'IBANKER'" :title="acct.account_type.toLowerCase() + ' account'">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 481.2 481.2">
                                    <path d="M180.1 308.3l78.5 23.8c-0.1 0.5-0.3 1.1-0.5 1.6 -2.1 5.7-6.4 8.9-13.4 10 -25.8 4.1-68.6 1.5-69 1.5 -6.6-0.4-12.3 4.6-12.7 11.2s4.6 12.3 11.2 12.7c1.9 0.1 45.8 2.8 74.3-1.8 28.3-4.5 36.4-29.4 34.9-45.1 -0.5-4.9-3.8-9-8.5-10.4l-87.9-26.6c-43.4-13.1-91 11.1-93 12.1 -0.2 0.1-0.5 0.2-0.7 0.4l-87.5 52.9c-5.7 3.4-7.5 10.8-4.1 16.5 2.3 3.7 6.2 5.8 10.3 5.8 2.1 0 4.2-0.6 6.2-1.7l87.1-52.5C109.1 316.7 147.4 298.4 180.1 308.3z"></path>
                                    <path d="M479.7 288.2c-6.9-12.6-28.4-32.7-61-18.3 -30.8 13.7-95.9 45-96.6 45.3 -6 2.9-8.5 10-5.6 16s10.1 8.5 16 5.6c0.7-0.3 65.4-31.5 95.9-45 8.7-3.9 16-3.9 22.3 0 0.2 0.1 0.3 0.2 0.5 0.3l-163.1 119.5c-11.6 8.5-26.3 12-40.4 9.8l-145.5-23.2c-3.4-0.5-6.9 0.4-9.6 2.6l-36.8 30.7c-5.1 4.2-5.8 11.8-1.5 16.9 2.4 2.8 5.8 4.3 9.2 4.3 2.7 0 5.4-0.9 7.7-2.8l32.6-27.2 140.2 22.4c20.4 3.3 41.7-1.9 58.4-14.1l174-127.4C481.1 300 482.6 293.5 479.7 288.2z"></path>
                                    <path d="M257.4 274.4c18.7 0 36.2-7.3 49.5-20.5 27.3-27.3 27.3-71.6 0-98.9 -13.2-13.2-30.8-20.5-49.5-20.5 -18.7 0-36.2 7.3-49.5 20.5 -27.3 27.3-27.3 71.6 0 98.9C221.2 267.1 238.7 274.4 257.4 274.4zM224.9 172c8.7-8.7 20.2-13.5 32.5-13.5 12.3 0 23.8 4.8 32.5 13.5 17.9 17.9 17.9 47.1 0 65 -8.7 8.7-20.2 13.5-32.5 13.5 -12.3 0-23.8-4.8-32.5-13.5C207 219.1 207 189.9 224.9 172z"></path>
                                    <path d="M339.5 137.7c14.6 0 28.3-5.7 38.6-16 21.3-21.3 21.3-55.9 0-77.2 -10.3-10.3-24-16-38.6-16s-28.3 5.7-38.6 16c-21.3 21.3-21.3 55.9 0 77.2C311.2 132.1 325 137.7 339.5 137.7zM317.9 61.5c5.8-5.8 13.5-9 21.7-9s15.9 3.2 21.7 9c11.9 11.9 11.9 31.4 0 43.3 -5.8 5.8-13.5 9-21.7 9s-15.9-3.2-21.7-9C306 92.8 306 73.4 317.9 61.5z"></path>
                                </svg>
                            </span>
                                <span v-if="acct.account_type === 'WALLET'" :title="acct.account_type.toLowerCase() + ' account'">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 487.6 487.6"><path d="M460.3 216.6h-11.6v-69.7c0-28.5-23.2-51.6-51.6-51.6h-10.7l0.1-25.9c0-19.2-15.6-34.8-34.8-34.8H42.3c-23.1 0-42 18.6-42.3 41.7 0 0.2 0 0.4 0 0.6v341.4c0 19.2 15.6 34.8 34.8 34.8h362.4c28.5 0 51.6-23.2 51.6-51.6v-69.8h11.6c15 0 27.2-12.2 27.2-27.2v-60.7C487.5 228.8 475.3 216.6 460.3 216.6zM42.3 58.6h309.4c5.9 0 10.8 4.8 10.8 10.7l-0.1 26H42.3c-10.1 0-18.3-8.2-18.3-18.3S32.2 58.6 42.3 58.6zM424.7 401.4c0 15.2-12.4 27.6-27.6 27.6H34.7c-5.9 0-10.8-4.8-10.8-10.8v-303.1c5.6 2.7 11.8 4.2 18.4 4.2h354.8c15.2 0 27.6 12.4 27.6 27.6v69.7h-81.9c-15 0-27.2 12.2-27.2 27.2v60.7c0 15 12.2 27.2 27.2 27.2h81.9V401.4zM463.5 304.5c0 1.8-1.4 3.2-3.2 3.2H342.9c-1.8 0-3.2-1.4-3.2-3.2v-60.7c0-1.7 1.4-3.2 3.2-3.2h117.4c1.7 0 3.2 1.4 3.2 3.2L463.5 304.5 463.5 304.5z"></path></svg>
                            </span>
                                <span v-if="acct.account_type === 'COOPERATE'" :title="acct.account_type.toLowerCase() + ' account'">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 487.6 487.6"><path d="M460.3 216.6h-11.6v-69.7c0-28.5-23.2-51.6-51.6-51.6h-10.7l0.1-25.9c0-19.2-15.6-34.8-34.8-34.8H42.3c-23.1 0-42 18.6-42.3 41.7 0 0.2 0 0.4 0 0.6v341.4c0 19.2 15.6 34.8 34.8 34.8h362.4c28.5 0 51.6-23.2 51.6-51.6v-69.8h11.6c15 0 27.2-12.2 27.2-27.2v-60.7C487.5 228.8 475.3 216.6 460.3 216.6zM42.3 58.6h309.4c5.9 0 10.8 4.8 10.8 10.7l-0.1 26H42.3c-10.1 0-18.3-8.2-18.3-18.3S32.2 58.6 42.3 58.6zM424.7 401.4c0 15.2-12.4 27.6-27.6 27.6H34.7c-5.9 0-10.8-4.8-10.8-10.8v-303.1c5.6 2.7 11.8 4.2 18.4 4.2h354.8c15.2 0 27.6 12.4 27.6 27.6v69.7h-81.9c-15 0-27.2 12.2-27.2 27.2v60.7c0 15 12.2 27.2 27.2 27.2h81.9V401.4zM463.5 304.5c0 1.8-1.4 3.2-3.2 3.2H342.9c-1.8 0-3.2-1.4-3.2-3.2v-60.7c0-1.7 1.4-3.2 3.2-3.2h117.4c1.7 0 3.2 1.4 3.2 3.2L463.5 304.5 463.5 304.5z"></path></svg>
                            </span>
                                {{acct.accountno}}
                            </p>
                            <p class="balance-tag">Balance</p>
                            <p class="balance"><span class="currency">₦</span>{{acct.availablebalance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</p>
                            <div class="base-section">
                                <div class="row">
                                    <div class="col-6">
                                        <!---->
                                        <!--<a @click="goToRequestStatement(acct)">History</a>-->
                                    </div>

                                    <div class="col-6 right-side">
                                        <!--<a @click="goToFundAccount(acct)">Fund</a>-->
                                        <a @click="goToRequestStatement(acct)">Account Statement</a>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="account-card-alt" @click="goToAddAccount()">
                        <div class="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 294.8 294.8">
                                <path d="M251.6 43.2c-11.3-11.3-23.9-20.5-37.6-27.3 -3-1.5-6.6-0.3-8 2.7 -1.5 3-0.3 6.6 2.7 8 12.5 6.2 24.1 14.6 34.4 25 52.8 52.8 52.8 138.7 0 191.5s-138.7 52.8-191.5 0 -52.8-138.7 0-191.5C77.2 26.1 111.2 12 147.4 12c3.3 0 6-2.7 6-6s-2.7-6-6-6C108 0 71 15.3 43.1 43.2c-57.5 57.5-57.5 151 0 208.5 28.7 28.7 66.5 43.1 104.2 43.1s75.5-14.4 104.2-43.1C309.1 194.2 309.1 100.7 251.6 43.2z"></path>
                                <path d="M147.4 52c-3.3 0-6 2.7-6 6v178.9c0 3.3 2.7 6 6 6s6-2.7 6-6V58C153.4 54.7 150.7 52 147.4 52z"></path>
                                <path d="M171.4 153.4h65.4c3.3 0 6-2.7 6-6s-2.7-6-6-6h-65.4c-3.3 0-6 2.7-6 6S168.1 153.4 171.4 153.4z"></path>
                                <path d="M58 141.4c-3.3 0-6 2.7-6 6s2.7 6 6 6h63.4c3.3 0 6-2.7 6-6s-2.7-6-6-6H58z"></path>
                            </svg>
                        </div>
                        <p>Add Account</p>
                    </div>
                </div>
            </div>

            <!--        Table-->
            <div class="history-table">
                <div class="tbl">

                    <div v-if="filteredHistory.toString() === ''">
                        <div class="empty-history">
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                <circle cx="25" cy="25" r="25"></circle>
                                <line x1="25" y1="10" x2="25" y2="32" class="a"></line>
                                <line x1="25" y1="37" x2="25" y2="39" class="a"></line>
                            </svg>
                        </span>
                            <p>
                                No recent transaction on this account!
                            </p>
                        </div>
                    </div>
                    <div v-else>
                        <div v-for="record in filteredHistory" class="account-statement-group">
                            <div v-for="(value, key) in record">
                                <span class="date">{{key | formatDateRelatively}}</span>

                                <div v-for="hist in value" class="account-statement">
                                    <article class="amount">
                                        <div v-if="hist.drcr === 'C'" class="crd"></div>
                                        <div v-if="hist.drcr === 'D'" class="dbt"></div>

                                        <!--<img :src="hist.logourl" class="history-icon" alt="">-->

                                        <span class="currency">&#8358;</span> {{hist.amount}}
                                    </article>
                                    <article class="type">{{hist.counterpartyservice | firstCaseCapitalSpace}}</article>
                                    <article class="counterparty">
                                        <p class="hist-narration" :title="hist.narration">{{hist.counterparty | firstCaseCapitalSpace}}</p>
                                    </article>
                                    <article class="icon">
                                        <a @click="openHistoryModal(hist)"><span class="fa fa-eye"></span></a>
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!--UI Modal For Displaying Full Details of a Transaction-->
                <ui-modal
                        ref="fullHistoryModal" transition="scale-up"
                        :removeHeader= "true" size="small" @hide="fullHistoryModalHide"
                        align-top :align-top-margin="50"
                >
                    <div class="notification-modal sm">
                        <div class="head">
                            <div class="logo-hold">
                                <div>
                                    <img src="https://assets-base.s3.amazonaws.com/img/rubies/logo-sm.png" alt="" class="logo">
                                </div>
                            </div>
                        </div>

                        <div class="bottom">
                            <div class="modal-body history">
                                <div class="">
                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-4 col-sm-4">
                                                <div class="logo">
                                                    <div v-if="currentFullHistory.trntype === 'AIRTIME' || currentFullHistory.trntype === 'MOBILEDATA'">
                                                        <img
                                                                v-if="currentFullHistory.counterpartybank === 'MTN'"
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/mtn-logo.png"
                                                                alt="MTN"
                                                        >
                                                        <img
                                                                v-else-if="currentFullHistory.counterpartybank === 'AIRTEL'"
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/airtel-logo.png"
                                                                alt="MTN"
                                                        >
                                                        <img
                                                                v-else-if="currentFullHistory.counterpartybank === 'GLO'"
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/glo-logo.png"
                                                                alt="MTN"
                                                        >
                                                        <img
                                                                v-else-if="currentFullHistory.counterpartybank === '9MOBILE'"
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/9mobile-logo.png"
                                                                alt="MTN"
                                                        >
                                                        <img
                                                                v-else
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/invoice.png"
                                                                alt="NETWORK"
                                                        >
                                                    </div>
                                                    <div v-else-if="currentFullHistory.trntype === 'BILLSPAYMENT'">
                                                        <img
                                                                v-if="currentFullHistory.counterpartybank === 'MTN'"
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/mtn-logo.png"
                                                                alt="MTN"
                                                        >
                                                        <img
                                                                v-else-if="currentFullHistory.counterpartybank === 'AIRTEL'"
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/airtel-logo.png"
                                                                alt="MTN"
                                                        >
                                                        <img
                                                                v-else-if="currentFullHistory.counterpartybank === 'GLO'"
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/glo-logo.png"
                                                                alt="MTN"
                                                        >
                                                        <img
                                                                v-else-if="currentFullHistory.counterpartybank === '9MOBILE'"
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/9mobile-logo.png"
                                                                alt="MTN"
                                                        >
                                                        <img
                                                                v-else
                                                                src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/invoice.png"
                                                                alt="BILLS PAYMENT"
                                                        >
                                                    </div>
                                                    <div v-else-if="currentFullHistory.trntype === 'MONEYREQUEST'">
                                                        <img src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/money-request.png" class="alt" alt="">
                                                    </div>
                                                    <div v-else-if="currentFullHistory.trntype === 'OUTWARD' || currentFullHistory.trntype === 'TRANSFER'">
                                                        <img :src="currentFullHistory.logourl" alt="">
                                                    </div>
                                                    <div v-else>
                                                        <img src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/invoice.png" class="alt" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-8 col-sm-8 text-right">
                                                <div class="amount">
                                                    <div class="crdDbt">
                                                        <span v-if="currentFullHistory.drcr === 'C'" class="crd"></span>
                                                        <span v-else="currentFullHistory.drcr === 'D'" class="dbt"></span>
                                                    </div>

                                                    <p v-if="currentFullHistory.amount">
                                                        <span class="currency">₦</span>
                                                        {{currentFullHistory.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-4 col-sm-4">
                                                <p class="histLabel">Account</p>
                                            </div>
                                            <div class="col-8 col-sm-8 text-right">
                                                <p class="histRecord">{{currentFullHistory.accountname}} ({{currentFullHistory.account}})</p>
                                            </div>
                                        </div>
                                    </div>

                                    <hr>

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-4 col-sm-4">
                                                <p class="histLabel">Counterparty</p>
                                            </div>
                                            <div class="col-8 col-sm-8 text-right">
                                                <p class="histRecord">
                                                    {{currentFullHistory.counterparty}}
                                                    <span v-if="currentFullHistory.counterpartyaccount">
                                                    ({{currentFullHistory.counterpartyaccount}})
                                                </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <hr>

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-4 col-sm-4">
                                                <p class="histLabel">Date</p>
                                            </div>
                                            <div class="col-8 col-sm-8 text-right">
                                                <p class="histRecord">{{currentFullHistory.eventdate}}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <hr >

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-4 col-sm-4">
                                                <p class="histLabel">Type</p>
                                            </div>
                                            <div class="col-8 col-sm-8 text-right">
                                                <p class="histRecord">{{currentFullHistory.trntype}}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <hr >

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-4 col-sm-4">
                                                <p class="histLabel">Channel/Service</p>
                                            </div>
                                            <div class="col-8 col-sm-8 text-right">
                                                <p class="histRecord">{{currentFullHistory.counterpartychannel}}/{{currentFullHistory.counterpartyservice}}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <hr >

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-4 col-sm-4">
                                                <p class="histLabel">Ref</p>
                                            </div>
                                            <div class="col-8 col-sm-8 text-right">
                                                <p class="histRecord">{{currentFullHistory.contractref}}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <hr >

                                    <div class="trnxHist">
                                        <div class="row">
                                            <div class="col-4 col-sm-4">
                                                <p class="histLabel">Narration</p>
                                            </div>
                                            <div class="col-8 col-sm-8 text-right">
                                                <p class="histRecord">{{currentFullHistory.narration}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-button">
                                <button @click="closeModal('fullHistoryModal')" class="btn btn-primary btn-xnax-login ">Ok</button>
                            </div>
                        </div>
                    </div>
                </ui-modal>
            </div>


            <footer-mobile></footer-mobile>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    import MobileLeftBar from '../components/sidebar/MobileLeftBar'
    import FooterMobile from "./utility/FooterMobile";



    export default {
        name: "Dashboard",
        components: {
            FooterMobile,
            mobileLeftBar: MobileLeftBar,
        },
        data () {
            return {
                orderedAccountList: [],
                currentAccountCard: '',
                filteredHistory: [],
                currentFullHistory: [],


                alert: {
                    show: true,
                    type: 'success',
                    message: 'Invalid Credentials'
                },
            }
        },
        computed: {
            ...mapGetters([
                'getUsername',
                'startAppLoading',
                'stopAppLoading',
                'getDataOnLogin',
            ])
        },
        created () {
            this.orderedAccountList = this.getDataOnLogin.accountlist.sort(this.compare);

            this.currentAccountCard = this.orderedAccountList[0].accountno;

            this.selectThisAccountCard(this.currentAccountCard);
        },
        methods: {
            ...mapActions([
                'updateCurrentComponent',
                'updateDataOnLogin',
                'updateNetworkErrorState',
                'updateAppLoading',
                'updateInsideCurrentPage',
                'updateSideBarPage',
                'updateCurrentAccountForAction',
                'updateCurrentAccountToFund',
            ]),

            testNetworkErrorTrigger(){
                this.updateNetworkErrorState(true)
            },

            openModal(ref) {
                this.$refs[ref].open();
            },
            closeModal(ref) {
                this.$refs[ref].close();
            },

            //compare
            compare(a,b) {
                if (a.availablebalance > b.availablebalance)
                    return 1;
                if (a.availablebalance < b.availablebalance)
                    return -1;
                return 0;
            },

            getSum(total, num) {
                return total + num;
            },

            selectThisAccountCard(_accountNo){
                this.currentAccountCard = _accountNo

                let curDate = '';
                let txtCount = 0;
                let objOuter = {};
                let arrInner = [];

                let filtered = [];
                this.getDataOnLogin.transactionlist = this.getDataOnLogin.transactionlist.sort(function(a, b) {
                    let dateA = new Date(a.txndate), dateB = new Date(b.txndate);
                    return dateB - dateA;
                });
                for (let i = 0; i < this.getDataOnLogin.transactionlist.length; i++) {

                    // if (txtCount <= 4){
                        if (this.getDataOnLogin.transactionlist[i].account === _accountNo) {
                            if (curDate === ''){ curDate = this.getDataOnLogin.transactionlist[i].txndate;}

                            if (curDate === this.getDataOnLogin.transactionlist[i].txndate){
                                // // console.log('Each Transaction ==>>', this.getDataOnLogin.transactionlist[i]);
                                // // console.log('Array INNER Before PUSH ==>>', arrInner);

                                arrInner.push(this.getDataOnLogin.transactionlist[i]);
                                // // console.log('Array INNER AFTER PUSH ==>>', arrInner);
                                txtCount = txtCount+1

                                // // console.log('INDIVIDUAL COUNT TXTCOUNT ==>>', txtCount);

                                // if (txtCount === 5){
                                //     objOuter[curDate] = arrInner;
                                //     filtered.push(objOuter);
                                // }

                            } else {
                                if (arrInner){
                                    objOuter[curDate] = arrInner;
                                }

                                // // console.log('OBJECT OBJECT ==>>', objOuter);

                                filtered.push(objOuter);

                                arrInner = [];
                                objOuter = {};
                                curDate = this.getDataOnLogin.transactionlist[i].txndate;
                                arrInner.push(this.getDataOnLogin.transactionlist[i]);
                                // txtCount = txtCount+1
                            }
                        }
                    // }
                    // }
                }
                // // console.log('flag FLAG ==>>', filtered);
                // // console.log('COUNT TXTCOUNT ==>>', txtCount);

                this.filteredHistory = filtered;

                // // console.log('Final flag FLAG ==>>', this.filteredHistory);
            },

            goToAddAccount(){
                // Switch inside content to "add-account"
                // console.log('Go To Add Account!')
            },
            goToRequestStatement(_acct){
                // console.log('Request Statement', _acct)

                //Set the Current Account for action in the Store to the selected account
                this.updateCurrentAccountForAction(_acct);

                // Switch the page to Request Statement
                this.updateInsideCurrentPage('requestStatement');
                this.updateSideBarPage('account-statement');


            },
            goToFundAccount(_acct){
                // console.log('Go To Fund Account', _acct);

                this.updateCurrentAccountToFund([_acct.accountno, _acct.accountname]);

                // Switch the page to Request Statement
                this.updateInsideCurrentPage('fundMethod');
            },
            //    History
            openHistoryModal(_hist){
                // // console.log('History ==>>', _hist);

                this.currentFullHistory = _hist

                //Show Success Modal and then redirect to the home page / login page
                this.openModal('fullHistoryModal');
            },
            fullHistoryModalHide(){
                // change the currentComponent in the store to 'dashboard'
                // console.log('History Modal Close')
            },
        },
        mounted(){
            this.$nextTick(()=>{
                $(document).ready(function(){
                    $(".owl-carousel").owlCarousel({
                        items: 3,
                        loop:false,
                        margin:10,
                        dots:true,
                        responsiveClass:true,
                        responsive:{
                            0:{
                                items:1,
                            },
                            321:{
                                items:1,
                            },
                            576:{
                                items:2,
                            },
                            768:{
                                items:2,
                            },
                            800:{
                                items:3,
                            }
                        }
                    });
                });
            });
        },
    }
</script>

<style scoped>


    /*.header-sidebar*/
    /*display flex*/
    /*align-items center*/
    /*justify-content center*/
    /*flex-direction column*/
    /*width 100%*/
    /*h4*/
    /*display flex*/
    /*align-items center*/
    /*justify-content center*/
    /*width 100%*/
    /*> button*/
    /*margin-left 10px*/
                  /*.footer-sidebar*/
                  /*display flex*/
                  /*align-items center*/
                  /*justify-content space-between*/
                  /*width 100%*/
    /*> button*/
    /*border 0px solid rgba(0,0,0,0) !important*/
    /*border-left 1px solid rgba(0,0,0,.07) !important*/
    /*border-radius 0px !important*/
</style>
